module.exports = __webpack_public_path__ + "img/motorway_3x1_z16.f643b6a7.svg";